'use es6';

import { List } from 'immutable';
import PropTypes from 'prop-types';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import FileAttachmentsFooter from '../attachments/FileAttachmentsFooter';
import { isEmailCMF } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { getFilteredAttachments } from 'conversations-message-history/attachments/operators/imageAttachmentFilters';
import { getContentAttachments, getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { jsx as _jsx } from "react/jsx-runtime";
const CommonAttachmentsFooter = props => {
  const {
    fileAttachments = List(),
    message
  } = props;

  //remove header attachment from rest of the attachments
  const contentAttachments = getContentAttachments(message, fileAttachments);
  const genericChannelId = getGenericChannelId(message);
  const attachments = isEmailCMF(message) ? contentAttachments : getFilteredAttachments({
    fileAttachments: contentAttachments,
    canRender: false
  });
  return attachments && attachments.size ? /*#__PURE__*/_jsx(FileAttachmentsFooter, {
    fileAttachments: attachments,
    genericChannelId: genericChannelId
  }) : null;
};
CommonAttachmentsFooter.displayName = 'CommonAttachmentsFooter';
CommonAttachmentsFooter.propTypes = {
  fileAttachments: PropTypes.instanceOf(List),
  message: RecordPropType('CommonMessage').isRequired
};
export default CommonAttachmentsFooter;